module.exports = __webpack_public_path__ + "img/hero.bcdb64b7.jpg";